<template>
  <div style="position: relative">
    <h4 class="mb-4">
      Kanton, Bezirk, PLZ
    </h4>

    <button
      v-if="!editMode && canUserEdit"
      v-b-tooltip.hover
      type="button"
      placement="top"
      title="Kanton-Bezirk-PLZ bearbeiten"
      class="btn btn-primary"
      style="position: absolute; top: 0; right: 0; z-index: 1"
      @click="editMode = !editMode"
    >
      <i class="fas fa-edit" />
    </button>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <u-loader v-if="isloading" />
    <div v-else>
      <u-tree-view
        v-model="selectedCitiesId"
        item-key="path"
        :tree-view-items="treeViewData"
        :open-node-ids="treeNodesToOpen"
        :disabled="editMode && canUserEdit ? false : true"
      />

      <div
        v-if="editMode && canUserEdit"
        class="mt-4"
      >
        <button
          v-b-tooltip.hover
          type="button"
          placement="bottom"
          title="Speichern"
          class="btn btn-success ml-2"
          :disabled="requiredProperties.length != 0"
          @click="saveCities()"
        >
          Speichern
        </button>

        <button
          v-b-tooltip.hover
          type="button"
          placement="bottom"
          title="Abbrechen"
          class="btn btn-danger ml-2"
          @click="loadAllCities()"
        >
          Abbrechen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { GetAllCities } from "@/services/cantons.service.js";
import {
  GetPaths,
  UpdatePaths,
} from "@/services/contract.edition.cantons.service.js";
import UTreeView from "@/components/common/UTreeView.vue";
import { CreatedCountryMiloTreeView } from "@/helpers/TreeViewHelper.js";
import { AggregatePlzArray } from "@/helpers/PlzHelper.js";

export default {
  components: {
    UTreeView,
  },
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allCities: [],
      errorObject: null,
      isloading: false,
      editMode: false,
      requiredProperties: [],
      treeViewData: [],
      selectedCitiesId: [],
    };
  },
  computed: {
    autoCompleteDisabled() {
      return !this.editMode || !this.canUserEdit;
    },
    treeNodesToOpen() {
      let nodes = ["CH"];
      return nodes;
    },
  },
  created() {
    this.loadAllCities();
  },
  methods: {
    loadAllCities() {
      this.errorObject = null;
      this.isloading = true;
      this.editMode = false;
      var selectedCities = [];
      GetAllCities(
        (response) => {
          this.allCities = response;
          this.treeViewData = CreatedCountryMiloTreeView(response);
          GetPaths(
            this.contractId,
            this.versionId,
            this.editionId,
            (response) => {
              if (response) {
                response.map((city) => {
                  selectedCities.push(city.path);
                });
                this.selectedCitiesId = selectedCities;
                this.isloading = false;
              }
            },
            (error) => {
              this.isloading = false;
              this.errorObject = error;
            },
          );
        },
        (error) => {
          this.isloading = false;
          this.errorObject = error;
        },
      );
    },

    saveCities() {
      this.isloading = true;
      var allPaths = [];
      this.selectedCitiesId.map((path) => {
        allPaths.push({
          path: path,
          EditionId: this.editionId,
        });
      });

      allPaths = AggregatePlzArray(allPaths, this.treeViewData);

      UpdatePaths(
        this.contractId,
        this.versionId,
        this.editionId,
        allPaths,
        () => {
          this.isloading = false;
          this.loadAllCities();
        },
        (error) => {
          this.isloading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style scoped></style>
